<template>
  <div class="main">
    <div class="bg1"></div>
    <div class="bg2"></div>
    <!--顶部-->
    <div class="ltops">
      <div class="language">
        <div class="languagebox" @click="showChangeLangs">
          <div class="languagetitle animate" :class="ishow == true ? 'on' : ''">
            {{ columns[index] }}
            <i class="iconfont icon-xiala"></i>
          </div>
        </div>
        <van-popup v-model="ishow" position="bottom" :style="{ height: '30%' }">
          <van-picker :title="$t('common.lan_title')" :confirm-button-text="$t('member.login_out_ok')" :cancel-button-text="$t('member.login_out_cancel')" show-toolbar :columns="columns" :default-index="index" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
      </div>
    </div>
    <!--顶部 end-->
    <!--form表单-->
    <div class="lforms">
      <div class="lform">
        <div class="mform">
          <div class="mform_right">
            <input v-model="loginName" type="text" :placeholder="$t('login.uname_placeholder')" placeholder-style=" font-size:0.28rem; color:#ddd;" />
          </div>
        </div>
        <div class="mform">
          <div class="mform_right">
            <input v-model="loginPwd" type="password" password="true" :placeholder="$t('login.upwd_placeholder')" placeholder-style=" font-size:0.28rem; color:#ddd;" />
          </div>
        </div>
      </div>
      <div class="login_btn fs30" @click="doLogin">
        {{ $t('login.login_btn') }}
      </div>
      <div class="btns">
        <div class="forgot" @click="forgot">
          忘记密码
        </div>
        <div class="register" @click="doRegister">
          {{ $t('register.register_btn') }}
        </div>
      </div>
    </div>
    <!--form表单 end-->
  </div>
</template>

<script>
import Config from '@/utils/config'

export default {
  data () {
    return {
      columns: '',
      lan: '',
      index: '0', // 默认语种
      ishow: false, // 是否弹出语言选择
      loginName: '', // 用户名
      loginPwd: '', // 用户密码
      key: null, // 微信登录的key
    }
  },
  created () {
    this.setLan()
    // 获取传递的参数
    console.log('params', this.$route.params)
    this.key = this.$route.params.key
  },
  methods: {
    // 读取默认语言
    setLan () {
      var langs = this.$store.state.langs
      var langs_en = this.$store.state.langs_en
      var lan = localStorage.getItem('lan')
      if (this.$isblank(lan)) {
        lan = 0
      }
      this.$i18n.locale = langs_en[lan]
      this.index = lan
      this.columns = langs
      localStorage.setItem('language', langs_en[lan])
      localStorage.setItem('lan', lan)
    },

    // 弹出语言选择
    showChangeLangs () {
      this.ishow = true
    },

    // 语言选择触发
    onConfirm (value, i) {
      this.index = i
      this.ishow = false
      var langs_en = this.$store.state.langs_en
      this.$i18n.locale = langs_en[i]
      localStorage.setItem('language', langs_en[i])
      localStorage.setItem('lan', i)
    },

    // 隐藏语言选择层
    onCancel () {
      this.ishow = false
    },

    // 执行登录
    doLogin () {
      console.log(' Config.getAppId():', Config.getAppId())

      var loginName = this.loginName
      var loginPwd = this.loginPwd
      if (this.$isblank(loginName)) {
        // this.$toast( $t('login.msg_tis1') );return false;
        this.$toast(this.$t('login.msg_tis1'))
        return false
      }
      if (this.$isblank(loginPwd)) {
        this.$toast(this.$t('login.msg_tis2'))
        return false
      }
      var _this = this
      _this.$toast.loading({
        message: this.$t('login.login_loading'),
        forbidClick: true,
        duration: 0,
      })
      if (this.key) {
        // 微信端登录
        this.$api.wxLogin({
          loginName: loginName,
          loginPwd: _this.$md5(loginPwd),
          key: this.key,
          appid: Config.getAppId(),
        }).then((res) => {
          _this.$toast.clear()
          if (res.errcode === 0) {
            localStorage.setItem('username', loginName)
            localStorage.setItem('token', _this.key)


            this.subscript(res.token)

            _this.$router.push({ path: '/live' }).catch((err) => {
              console.log('err-->', err)
            })

          } else {
            _this.$toast(res.errmsg)
          }
        })
          .catch((err) => {
            // 其他异常
            console.log(err)
            _this.$toast.clear()
            // _this.$toast("连接超时");
          })
      } else {
        // H5登录
        this.$api
          .doLogin({
            loginName: loginName,
            loginPwd: _this.$md5(loginPwd),
          })
          .then((res) => {
            _this.$toast.clear()
            if (res.errcode == 0) {
              localStorage.setItem('token', res.token)
              localStorage.setItem('username', loginName)

              const { redirect } = this.$route.query
              this.subscript(res.token)

              _this.$router.push({ path: '/live' })
            } else {
              _this.$toast(res.errmsg)
            }
          })
          .catch((err) => {
            // 其他异常
            _this.$toast.clear()
            // _this.$toast("连接超时");
          })
      }
    },

    // 去注册
    doRegister () {
      this.$router.push('/register')
    },

    // 忘记密码
    forgot () {
      this.$router.push('/forgot')
    },

    // 订阅消息
    subscript (token) {
      // const that = this;
      // let index = 0;
      // try {
      //   let index = 0;
      //   setInterval(() => {
      //     console.log("index:", index);
      //     that.$store.dispatch("subscribe", ++index);
      //   }, 5000);
      // } catch (err) {
      //   console.error(err);
      // }
      try {
        // 打开SSE 订阅消息
        this.$openSSE()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(../../assets/images/lobg.jpg) top no-repeat;
  background-size: 100% 100%;
}

.languagebox {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50px;
  padding: 0.1rem 0.25rem;
  margin: 0.2rem 0.2rem;
}
.language {
  position: absolute;
  top: 10px;
  right: 5px;
}
.languagetitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  width: 80px;
  height: 20px;
  line-height: 20px;
}
.languagetitle i {
  position: absolute;
  right: 0.3rem;
  top: 0.3rem;
  width: 20px;
  height: 20px;
}

/*顶部*/
.bg1,
.bg2 {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.bg1 {
  top: 0;
}
.bg2 {
  bottom: 0;
}
.bg1 {
  background: url(../../assets/images/bg1.png) top no-repeat;
  background-size: 100% auto;
}
.bg2 {
  background: url(../../assets/images/bg2.png) bottom no-repeat;
  background-size: 100% auto;
}
.ltops {
  width: 100%;
  height: 220px;
  position: relative;
}
.logo {
  text-align: center;
  padding-top: 1rem;
}
.logo img {
  width: 2.71rem;
  height: 1.72rem;
}
/*顶部 end*/

/*form表单*/
.lforms {
  position: relative;
  background: rgba(0, 0, 0, 0.2);
  padding: 0.77rem 0 0.88rem;
  z-index: 100;
}
.mform .mform_right input::-webkit-input-placeholder {
  font-size: 13px;
}
.mform .mform_right input::-moz-placeholder {
  font-size: 13px;
}
.mform .mform_right input::-moz-placeholder {
  font-size: 13px;
}
.mform .mform_right input::-ms-input-placeholder {
  font-size: 13px;
}
.lform {
  width: 6rem;
  margin: 0 auto;
  padding: 0 0.2rem;
}
.mform {
  overflow: hidden;
  margin-bottom: 0.2rem;
  box-shadow: 0 0.05rem 0.1rem #827d88;
}
.mform .mform_left {
  width: 60px;
  float: left;
  font-size: 15px;
  font-weight: 700;
  line-height: 36px;
  color: #999;
}
.mform .mform_right {
  margin-left: 0px;
  font-weight: 700;
}
.mform .mform_right input {
  width: 100%;
  font-size: 18px;
  display: block;
  float: left;
  box-sizing: border-box;
  background: #fff;
  text-align: center;
  color: #32231a;
  padding: 13.5px 0;
}
.login_btn {
  width: 6rem;
  height: 48px;
  line-height: 48px;
  background: #27b0f6;
  text-align: center;
  color: #fff;
  margin: 0rem auto 0;
  font-size: 16px;
  box-shadow: 0 0.05rem 0.1rem #827d88;
  margin-bottom: 0.2rem;
}

.btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  width: 6rem;
}

.register {
  font-size: 0.4rem;
  color: #4877ea;
}

.forgot {
  font-size: 0.4rem;
  color: #4877ea;
}
/*form表单 end*/
</style>
